import React, { useEffect, useState } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import { Route } from 'react-router';
import InfosecAssessment from './assessment';
import InfosecAuth from './auth';
import InfosecJoin from './join';
import InfosecFinish from './finish';
import { joinPath, querystring } from '../../utils/helpers';
import AssessmentsAnswerView from '../Assessments/AssessmentsAnswerView';
import { useStores } from '../../hooks/use-stores';
import { observer } from 'mobx-react';
import { useCmi5 } from '../../hooks/use-cmi5';
// eslint-disable-next-line no-unused-vars
import AssessmentResults from '../Assessments/AssessmentResults';

function InfosecHome({ variant = 'infosec' }) {
    const match = useRouteMatch();
    const { authStore, assessmentStore, questionStore } = useStores();
    const { isAuthenticated, currentUser } = authStore;
    const [isCmi5Initialized, setIsCmi5Initialized] = useState();
    const [initializationError, setInitializationError] = useState();

    const cmi5 = useCmi5();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        initCMI5();
    }, []);

    const initCMI5 = () => {
        if (cmi5) {
            authStore.forgetUser();
            cmi5.initialize()
                .then(() => {
                    setIsCmi5Initialized(cmi5.isAuthenticated);
                })
                .catch((e) => {
                    setInitializationError(e);
                });
        }
    };
    if (cmi5) {
        if (initializationError) return initializationError.message;
        if (!isCmi5Initialized) return 'Initializing';
    }

    return (
        <Switch>
            <Route
                exact
                path={match.url}
                render={() => {
                    if (isAuthenticated)
                        return (
                            <Redirect
                                to={`${joinPath(match.url, 'assessment')}`}
                            />
                        );
                    else
                        return (
                            <InfosecAuth
                                variant={variant}
                                parentMatch={match}
                            />
                        );
                }}
            />
            <Route
                path={`${joinPath(match.url, 'join')}`}
                render={() => <InfosecJoin parentMatch={match} />}
            />
            <Route
                render={() => {
                    if (!isAuthenticated) return <Redirect to={match.url} />;
                    else
                        return (
                            <Switch>
                                <Route
                                    path={`${joinPath(
                                        match.url,
                                        'assessment/answers'
                                    )}`}
                                    render={() => {
                                        let questionIndex =
                                            querystring('index');
                                        return (
                                            <>
                                                {' '}
                                                <AssessmentsAnswerView
                                                    companyId={variant}
                                                    assessmentId={variant}
                                                    assessmentStore={
                                                        assessmentStore
                                                    }
                                                    questionStore={
                                                        questionStore
                                                    }
                                                    currentUser={currentUser}
                                                    parentUrl={match.url}
                                                    index={questionIndex}
                                                />
                                            </>
                                        );
                                    }}
                                />

                                <Route
                                    path={`${joinPath(
                                        match.url,
                                        ':id/answers'
                                    )}`}
                                    render={() => {
                                        let questionIndex =
                                            querystring('index');
                                        return (
                                            <Redirect
                                                to={`${joinPath(
                                                    match.url,
                                                    `assessment/answers${
                                                        questionIndex
                                                            ? `?index=${questionIndex}`
                                                            : ''
                                                    }`
                                                )}`}
                                            />
                                        );
                                    }}
                                />
                                <Route
                                    path={`${joinPath(match.url, 'finish')}`}
                                    render={() => <InfosecFinish />}
                                />

                                <Route
                                    path={`${joinPath(
                                        match.url,
                                        'assessment'
                                    )}`}
                                    render={() => (
                                        <InfosecAssessment
                                            variant={variant}
                                            parentMatch={match}
                                        />
                                    )}
                                />
                            </Switch>
                        );
                }}
            />
        </Switch>
    );
}

export default observer(InfosecHome);
